import React from "react";

import UploadImageBundle from "./img/UploadImageBundle.png";
import aitestbundle from "./img/aitestbundle.jpg";
import { AiFillGithub } from "react-icons/ai";
import "./Bundle.css";

const projets = [
  {
    titre: "UploadImageBundle",
    type: "Symfony",
    images: [UploadImageBundle],
    lien: "https://github.com/antonio150/UploadImageBundle",
    description: `UploadImageBundle est un bundle Symfony qui offre un moyen simple de télécharger 
                et de gérer des images dans votre application Symfony.`,
    installation: `composer require antonio150/uploadimagebundle:dev-main`
  },
  {
    titre: "AiTestBundle",
    type: "Symfony",
    images: [aitestbundle],
    lien: "https://github.com/antonio150/AiTestBundle",
    description: `AiTestBundle est un bundle Symfony qui permet de générer automatiquement des tests PHPUnit à partir de vos contrôleurs.`,
    installation: `composer require antonio/aitestbundle`
  }
];
const Bundle = () => {
  return (
    <div class="projet" id="bundle">
      <div class="title">BUNDLE SYMFONY</div>
      <div className="react_content">
      {projets.map((p, idx) =>
        <div key={idx} >
          <div class="react_content">
            <div id="bundle_div">
              <div class="bundle_title_projet">
                {p.titre}
              </div>
              <a href={p.lien} target="_blank" rel="noopener noreferrer">
                <img id="bundle_img" src={p.images} alt={"antonio navira " + p.titre} />
              </a>
              <ul>
                <li>
                  <a
                    id="bundle_link"
                    target="_blank"
                    rel="noopener noreferrer"
                    href={p.lien}
                  >
                    Voir <b>Répositorie</b> <AiFillGithub />
                  </a>
                </li>
                <li>
                  <div id="bundle_description_title">Installation</div>

                  <div id="bundle_description_txt">
                    <b>
                      {p.installation}
                    </b>
                  </div>

                  <div id="bundle_description_txt">
                    {p.description}
                  </div>
                </li>
              </ul>
            </div>
          </div>
        </div>
      )}
    </div>
    </div>
  );
};

export default Bundle;
